import React from 'react';
import { MenuItem } from '../../components/Menu';
import newTabIcon from '../../icons/non-prefilled/16x16/newTab.svg';

interface OpenInNewTabMenuItemProps {
  link: string;
}

const OpenInNewTabMenuItem = ({ link }: OpenInNewTabMenuItemProps) => {
  return (
    <MenuItem icon={newTabIcon} to={link} newTab>
      Open in new tab
    </MenuItem>
  );
};

export default OpenInNewTabMenuItem;
